import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class Partnercontdetails extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            studioUrl: this.decryptconfigdata('studioUrl'),
            resel_customer: [],
            activePage: 1,
            item_count: '',
            item_count: '',
            walkindetails: ''
           }
            this.handlePageChange = this.handlePageChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }
  
    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    
    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        this.getResellerCustomers(pageNumber);
      }
    getWalkinDetails() {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.intranet_body').addClass('hidden');
        });
        fetch(this.state.apiUrl + '/AdvancedRest/PartnerContactDetails/id/' + this.props.match.params.id + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                $(document).ready(function () {
                $('.loader-new').addClass('hidden');
                $('.intranet_body').removeClass('hidden');
            });
                responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                    walkindetails: responseJson.walkindetails,
                }) 
        })
    }
 
    
    componentDidMount() {
        document.title = "Wakin Details";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
          }
        this.getWalkinDetails();
    }
    
    render() {
        if (this.state.redirect) {
            return (
              <Redirect to={'/login'} />
              
            )
          }
        return (
            <div>
                <Header brecum_name="Partner Contacts" brecum_page="Partner Contacts" />
            <div class="right_col">
            <div class="loader-new"></div>
            <section class="intranet_body hidden">
                <div className="red">{this.state.message}</div>
            <div class="title mob hidden-md"><HeaderMob page_name="Partner Contact" /></div>
        <div class="title emps_mob">
            <div className="red">{this.state.walkindetails.nameaaa}</div>
            <span class="job_title hidden-xs">Partner Details</span>
            <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
            <div class="form-section border-bottom ">
                    <div class="details">
                        <div class="candidate_details_title">Name :</div>
                        <div class="candidate_details_des">
                            {this.state.walkindetails.name ? this.state.walkindetails.name : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Company :</div>
                        <div class="candidate_details_des">
                            {this.state.walkindetails.company ? this.state.walkindetails.company : '--'}
                        </div>
                    </div>            
                    <div class="details">
                        <div class="candidate_details_title">Phone :</div>
                        <div class="candidate_details_des">
                            {this.state.walkindetails.phone ? this.state.walkindetails.phone : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Email :</div>
                        <div class="candidate_details_des">
                        {this.state.walkindetails.email ? this.state.walkindetails.email : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Country :</div>
                        <div class="candidate_details_des">
                        {this.state.walkindetails.country ? this.state.walkindetails.country : '--'}
                        </div>
                    </div>
                    <div class="details">
                    <div class="candidate_details_title">Partner Name :</div>
                    <div class="candidate_details_des">
                    {this.state.walkindetails.partner_name ? this.state.walkindetails.partner_name : '--'}
                    </div>
                    </div>
                    <div class="details">
                    <div class="candidate_details_title">partner Email :</div>
                    <div class="candidate_details_des">
                    {this.state.walkindetails.partner_email_address ? this.state.walkindetails.partner_email_address : '--'}
                    </div>
                    </div>
                    <div class="details">
                    <div class="candidate_details_title">Source:</div>
                    <div class="candidate_details_des">
                    {this.state.walkindetails.source ? this.state.walkindetails.source : '--'}
                    </div>
                    </div>
                    <div class="details">
                    <div class="candidate_details_title">Ip Address:</div>
                    <div class="candidate_details_des">
                    {this.state.walkindetails.ip_address ? this.state.walkindetails.ip_address : '--'}
                    </div>
                    </div>
                    <div class="details">
                    <div class="candidate_details_title">Date:</div>
                    <div class="candidate_details_des">
                    {this.state.walkindetails.created_date ? this.state.walkindetails.created_date : '--'}
                    </div>
                    </div>
                    
                </div>
     
        </div>
        </section>
        </div>
        </div>
        )
    }
}
export default Partnercontdetails;


// WEBPACK FOOTER //
// ./src/components/advanced/Partnercontdetails.js